import React, { Component, createRef } from "react";
import FJResourceCommon from 'fj-components/FJResourceView'
import styles from './FJResourcesTransitionCommon.module.less';
import $ from 'jquery';
import FJTransitionPreview from "./FJTransitionPreview";
import FJUtil from '../../../util/FJUtil';
import FJConfig from "../../../config/FJConfig";
import FJLocalStore from "../../../store/FJLocalStore";
import {FJTransitionStore} from 'fj-graph'

class FJResourcesTransitionCommon extends Component {

	constructor(props) {
		super(props);
		this.state = {
			progress: 0.25,
			width: 136,
			height: 84
		};
		this._resourceCommon = createRef();
		this.transitionRef = createRef();
		this.tipsBox = createRef();
	}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!this._isInit) {
      this.initTransition();
    }
  }

  _cursorPoint = null;  // 开始拖动时的鼠标位置
	_isDragStart = false; // 是否经历了开始拖动
	_cursorPointInCloneNode = null; // 拖动时鼠标相对于节点的位置
	_cloneNode = null;   // 跟随鼠标移动的节点
	_video = null;
	tips = null;
	_hide = false;
	_time = null;

  initTransition = () => {
		if (this._isInit)
			return;
		this.ctx = this.canvas.getContext('2d');
		let size = {width: this.state.width, height: this.state.height};
		this.fromCanvas = document.createElement('canvas');
		this.toCanvas = document.createElement('canvas');
		let fromCtx = this.fromCanvas.getContext('2d');
		let toCtx = this.toCanvas.getContext('2d');
		this.fromCanvas.width = size.width;
		this.fromCanvas.height = size.height;
		this.toCanvas.width = size.width;
		this.toCanvas.height = size.height;
		let promiseFrom = FJUtil.loadImage(FJConfig.fromImg).then((image) => {
			fromCtx.drawImage(image, 0, 0, size.width, size.height);
		});
		let promiseTo = FJUtil.loadImage(FJConfig.toImg).then((image) => {
			toCtx.drawImage(image, 0, 0, size.width, size.height);
		});
		Promise.all([promiseFrom, promiseTo]).then(() => {
			this.imageLoaded = true;
			this._draw();
		});
	};

	/**
	 * 将当前进度的画面绘制到画板上
	 * @private
	 */
	_draw = () => {
		if (this.imageLoaded) {
		  let {width, height, progress} = this.state;
			let transition = FJTransitionStore.getGLTransition({width, height}, this.props.transitionName);
			if (transition) {
				let result = FJTransitionStore.glTransition(transition, progress, this.fromCanvas, this.toCanvas);
				this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
				this.ctx.drawImage(result, 0, 0);
        this._isInit = true;
      }
		}
	};

	/**
	 * 处理控制器选中事件
	 */
	handleSelect = () => {
		if (this.props.handleSelect) {
			this.props.handleSelect(this.props.transitionName);
		}
	};

	/**
	 * 处理控制器返回的progress信息
	 */
	handleProgress = (progress) => {
		this.setState({progress}, this._draw);
	};

	/**
	 * @description 点击添加
	 * @private
	 */
	_onAddClick = () => {
		if (this.props.onAddClick) {
			this.props.onAddClick(this.props.id, this.props.type);
		}
	};

	/**
	 * @description 选中
	 * @private
	 */
	_onMouseUp = () => {
		this.props.selectMedia(this.props.id, 2, 0);
	};

	/**
	 * @description 鼠标移动到素材的区域
	 * @private
	 */
	_onMouseEnter = (e) => {
		this._time = setTimeout(() => {
			this._hide = true;
			$(this.tipsBox.current).css({
				display: 'none'
			});
		}, 5000)
	};

	/**
	 * @description 鼠标在素材上移动
	 * @param e
	 * @private
	 */
	_onMouseMove = (e) => {
		if (!this.imageLoaded) return;
		if (this._hide) return;
		$(this.tipsBox.current).empty();
		this.tips = document.createElement('div');
		this.tips.innerHTML = FJLocalStore._('drag_timeline');
		$(this.tipsBox.current).css({
			display: 'block',
			left: e.clientX + 5,
			top: e.clientY + 20,
		});
		this.tipsBox.current.appendChild(this.tips);
	}

	/**
	 * @description 鼠标离开素材的区域
	 * @private
	 */
	_onMouseLeave = () => {
		$(this.tipsBox.current).empty();
		$(this.tipsBox.current).css({
			display: 'none'
		});
		this.tips = null;
		this._hide = false;
		clearTimeout(this._time);
	};

	/**
	 * @description 拖动
	 * @param e
	 * @param eventType
	 * @private
	 */
	_onDrag = (e, eventType) => {

		let point = {
			x: e.clientX,
			y: e.clientY,
		};

		switch (eventType) {
			case 'start': {
				this.props.selectMedia(this.props.id, 2, 0);
				this._recordPoint(e);
				this._isDragStart = true;

				let {left, top} = this._resourceCommon.current.mediaEle.current.getBoundingClientRect();

				this._cursorPointInCloneNode = {
					x: point.x - left,
					y: point.y - top,
				};
				this._updateContentCloneNode(point, this._cursorPointInCloneNode);

				if (this.props.onMediaDrag) {
					this._doMediaFrag(e, point, eventType)
				}

				break;
			}
			case 'change':
				if (this.props.onMediaDrag) {
					this._doMediaFrag(e, point, eventType)
				} else {
					this._updateContentCloneNode(point, this._cursorPointInCloneNode);
				}
				break;
			case 'end':
				this._isDragStart = false;
				if (this.props.onMediaDrag) {
					this._doMediaFrag(e, point, eventType)
				}
				this._removeContentCloneNode();
				break;
			default:
		}
	};

	_doMediaFrag = (e, point, eventType) => {
		this.props.onMediaDrag(e, {
			id: this.props.id,
			getUrl: this._getMediaUrl(),
			eventType: eventType
		}, (type) => {
			if (type === 'delete') {
				this._removeContentCloneNode();
			} else if (type === 'create') {
				this._updateContentCloneNode(point, this._cursorPointInCloneNode);
			} else if (type === 'continue') {
				this._updateContentCloneNode(point, this._cursorPointInCloneNode);
			}
		});
	};

	/**
	 * @description 得到媒体的Url
	 * @private
	 */
	_getMediaUrl = () => {
		let canvas = $(this.transitionRef.current).find('canvas')
		return  canvas[0].toDataURL('image/png');
	};

	/**
	 * @description 记录当前鼠标位置
	 * @param e
	 */
	_recordPoint = (e) => {
		this._cursorPoint = {
			x: e.clientX,
			y: e.clientY,
		}
	};

	/**
	 * @description 渲染随着鼠标拖动的div
	 * @param {Object} point
	 * @param {number} point.x
	 * @param {number} point.y
	 * @param {Object} offsetPoint
	 * @param {number} offsetPoint.x
	 * @param {number} offsetPoint.y
	 */
	_updateContentCloneNode = (point, offsetPoint) => {
		this._cloneNode = this._cloneNode || document.createElement('div');
		if (!$(this._cloneNode).html()) {
			this._cloneNode.appendChild(this._getDragNode());
		}
		document.body.appendChild(this._cloneNode);
		$(this._cloneNode).css({
			visibility: 'visible',
			position: 'fixed',
			bottom: 'inherit',
      left: point.x - offsetPoint.x,
      top: point.y - offsetPoint.y,
      width: this.props.width,
      cursor: 'move',
      zIndex: 99999,
      opacity: .8,
		});
	};

	/**
	 * @description 得到拖动时候显示的div
	 * @returns {HTMLDivElement}
	 * @private
	 */
	_getDragNode = () => {
		let node = document.createElement('div');
		let imgNode = new Image();
		let canvas = $(this.transitionRef.current).find('canvas')
		imgNode.src= canvas[0].toDataURL('image/png');
		imgNode.draggable = false;
		$(node).append(imgNode);
		$(node).addClass(styles.drag_other_img);
		$(node).css({
			width: this.props.width,
			height: this.props.height,
			background: 'rgba(242, 243, 247, 1)',
		});
		return node;
	};

	/**
	 * @description 删除添加的随着鼠标拖动的div
	 */
	_removeContentCloneNode = () => {
		if (this._cloneNode && this._cloneNode.parentNode) {
			this._cloneNode.parentNode.removeChild(this._cloneNode);
			this._cloneNode = null;
		}
	};

	render() {
		let {
			width,
			height,
			marginRight,
			marginBottom,
			isChoose,
			hasName, // 是否显示名称
			name,
			addIconToolTip,
			classes,
			allTooltip,
			toggleTooltip,
			oneTooltip,
			isSelect
		} = this.props;

		return (
			<FJResourceCommon width={width}
			                  height={height}
			                  marginRight={marginRight}
			                  marginBottom={marginBottom}
			                  ref={this._resourceCommon}
			                  hasAddBtn={false}
			                  isCanShowHover
			                  isChoose={isChoose}
			                  hasName={hasName}
			                  name={name}
			                  fileText={name}
			                  onAddClick={this._onAddClick}
			                  onDrag={this._onDrag}
			                  onMouseUp={this._onMouseUp}
			                  onMouseEnter={this._onMouseEnter}
			                  onMouseLeave={this._onMouseLeave}
			                  addIconToolTip={addIconToolTip}
			                  classes={classes}
			                  allTooltip={allTooltip}
			                  toggleTooltip={toggleTooltip}
			                  oneTooltip={oneTooltip}
			                  className={styles.copy_outer_box}
												onMouseMove={this._onMouseMove}
			>
				<FJTransitionPreview handleProgress={this.handleProgress}
														 handleSelect={this.handleSelect}
														 defaultProgress={this.state.progress}
														 isSelect={isSelect}
				>
					<div className={styles.c_preview_transition_animation} ref={this.transitionRef}>
						<canvas width={this.state.width} height={this.state.height} ref={(ele) => {
							this.canvas = ele
						}}> </canvas>
					</div>
				</FJTransitionPreview>
				<div ref={this.tipsBox} className={styles.tips_box} />
			</FJResourceCommon>
		)
	}

}

export default FJResourcesTransitionCommon;